export const checkboxStyles = {
  margin: 0,

  '.MuiFormControlLabel-root.checkbox': {
    margin: 0,
  },

  '& .MuiFormControlLabel-root .MuiCheckbox-root': {
    padding: 0,
  },

  '& .MuiButtonBase-root': {
    padding: 0,
  },
};
